module.exports = __webpack_public_path__ + "img/toolbar_transaction.eb516135.png";